import React, { useEffect, useRef, useState } from "react";

import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import CustomButton from "../../components/Form/CustomButton";
import Helpers from "../../helpers/helpers";

import { Icon } from "@iconify/react/dist/iconify.js";
import AppDialog from "../../components/Common/AppDialog";
import Breadcrumb from "../../components/Common/Breadcrumb";
import TablePageControl from "../../components/Common/TablePageControl";
import CheckBox from "../../components/Form/CheckBox";
import CustomDrawer from "../../components/Form/CustomDrawer";
import Header from "../../components/VerticalLayout/Header";
import { getNotificationDetails, getNotificationListing, getReadNotification, resetNotificationActionState, resetNotificationState } from "../../store/notification/actions";
import NotificationDetails from "./NotificationDetails";

const ViewNotification = ({ userPermission, notificationListing, notificationDetails, readNotification, }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetNotificationState());
        return () => {
            dispatch(resetNotificationState());
        }
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [tabValue, setTabValue] = useState('all');
    const [checkAll, setCheckAll] = useState(false);
    const [openNotification, setOpenNotification] = useState(false);
    const [filterObject, setFilterObject] = useState({ title: '', content: '', created_date: '', status: '0', rating: '0' });
    const [page, setPage] = useState(1);
    const [length, setLength] = useState("10");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("created_at");
    const [selectedNotification, setSelectedNotification] = useState([]);
    const [selectedRowID, setSelectedRowID] = useState("");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const searchRef = useRef();

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        setPage(page === 1 ? '1' : 1);
        setCheckAll(false);
        setSelectedNotification([]);
    }, [tabValue])

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by]);

    useEffect(() => {
        if (Boolean(selectedRowID)) {
            setIsLoading(true);
            dispatch(getNotificationDetails({ id: selectedRowID }));
        }
    }, [selectedRowID])

    useEffect(() => {
        if (notificationDetails?.id) {
            setOpenNotification(true);
        }
        setIsLoading(false);
    }, [notificationDetails])

    useEffect(() => {
        if (notificationListing?.data) {
            setIsLoading(false);
        }
    }, [notificationListing])

    const initData = () => {
        setIsLoading(true);
        let payload = {
            paginate: page,
            sort_order: sort,
            sort_by: sort_by,
            size: length,
            search: searchRef.current,
            isUnread: tabValue === 'unread' ? 1 : '',
            sort: sort_by,
        }
        dispatch(getNotificationListing(payload))
    }

    const resetFilter = () => {
        let resetFilterObject = Object.keys(filterObject).reduce((acc, key) => {
            acc[key] = '';
            return acc;
        }, {})
        setFilterObject({ ...filterObject, ...resetFilterObject });
        setSearch('');
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
    };

    const handleMarkAsRead = () => {
        if (notificationDetails?.is_read !== 1) {
            setIsLoading(true);
            dispatch(getReadNotification({ ids: [notificationDetails?.id] }));
        }
    }
    const handleMarkAllAsRead = () => {
        setIsLoading(true);
        dispatch(getReadNotification({ ids: selectedNotification }));
    }

    useEffect(() => {
        if (readNotification?.code === "success") {
            setSelectedNotification([]);
            dispatch(resetNotificationActionState());
            initData();
            setIsLoading(false);
            if (selectedNotification?.length > 0) {
                setNotification({
                    open: true,
                    msg: "Mark as read successfully.",
                    type: "success",
                });
            }
        } else if (readNotification?.code === "error") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: readNotification?.message || "Something went wrong, please try again later.",
                type: "error",
            })
            dispatch(resetNotificationActionState());
            initData();
        }
    }, [readNotification])

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                initData();
            }
        }, Helpers.searchInterval);
    }

    const handleCheckBoxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedNotification([...selectedNotification, id]);
        } else {
            checkAll && setCheckAll(false);
            setSelectedNotification(selectedNotification.filter(x => x !== id));
        }
    }

    const handleCheckAllOnChange = (e) => {
        setCheckAll(e);
        if (e) {
            setSelectedNotification(
                notificationListing?.data?.filter((item) => item?.is_read !== 1)?.map((item) => item?.id) || []
            );
        } else if (!e && selectedNotification) {
            setSelectedNotification([]);
        }
    }

    const handleOpenNotification = (id) => {
        setSelectedRowID(id);
    }

    const applyFilter = (sort, sortBy) => {
        setSortBy(sortBy || "created_date");
        setSorted(sort || "desc");
        setPage(page === 1 ? '1' : 1);
        setDrawerOpen(false);
    }

    const filterList = [
        {
            label: "Sort By",
            data: Helpers?.sortByNotificationFilter,
            value: Helpers?.getSortStatus(sort, sort_by, 'title', 'created_at'),
            sortName1: "title",
            sortName2: "created_at",
            name: "sort_by",
            type: "radio",
        },
        {
            label: "Title",
            value: filterObject?.title || [],
            type: "text",
            placeholder: "Title",
            onChange: (e) => {
                setFilterObject({ ...filterObject, title: e })
            }
        },
        {
            label: "Description",
            value: filterObject?.description || [],
            type: "text",
            placeholder: "Description",
            onChange: (e) => {
                setFilterObject({ ...filterObject, description: e })
            }
        },
        {
            label: "Date",
            value: filterObject?.dateRangeType,
            startDate: startDate,
            endDate: endDate,
            setStartDate: setStartDate,
            setEndDate: setEndDate,
            dateRange: dateRange,
            type: "created_date",
            onChange: (e) => {
                setFilterObject({ ...filterObject, dateRangeType: e })
            },
        },

    ]

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid item container lg={12} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={2}>
                    <Grid item xs={12} sm={6} className="d-flex align-items-end">
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} >
                        <CustomButton
                            title={<><Icon icon={'fluent:checkmark-32-filled'} style={{ marginRight: 5, color: '#525252CC' }} />Mark as read</>}
                            press={() => handleMarkAllAsRead()}
                            height={32}
                            backgroundColor={'white'}
                            textColor={'#000'}
                            borderStyle={"1px solid #babcbe"}
                            marginRight={'10px'}
                        />
                        <CustomButton
                            title={<><Icon icon={'ri-filter-3-line'} style={{ marginRight: 5, color: '#525252CC' }} />Filter</>}
                            press={() => setDrawerOpen(true)}
                            height={32}
                            backgroundColor={'white'}
                            textColor={'#000'}
                            borderStyle={"1px solid #babcbe"}
                        />
                        {/* <PopOverFilter marginRight={'10px'} handleFilterApply={() => initData()} handleResetFilter={() => resetFilter()}>
                            <CustomTextField
                                title={'Title'}
                                values={filterObject?.title}
                                onChange={(e) => handleFilterChange('title', e)}
                                placeholder={'Search by keyword'}
                            />
                            <div className="my-3">
                                <CustomTextField
                                    title={'Description'}
                                    values={filterObject?.description}
                                    onChange={(e) => handleFilterChange('description', e)}
                                    placeholder={'Search by keyword'}
                                />
                            </div>
                            <CustomizedDatePicker
                                title={'Date'}
                                values={filterObject?.created_date && new Date(filterObject?.created_date)}
                                placeholder={"dd/mm/yyyy"}
                                setFormValues={(e) => setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    created_date: e
                                }))}
                            />
                        </PopOverFilter> */}
                    </Grid>
                </Grid>

            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content" style={{ minHeight: 850 }}>
                <LoadingDialog open={loading || !notificationListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Header
                        breadcrumb={<Breadcrumb breadcrumbItems={[{ title: "Notification", link: "#" }]} />}
                    />
                    {customToolsBar()}
                    <div className="d-flex align-items-center mt-1 mb-3">
                        <div className={`tab-container ${tabValue === "all" ? "selected-tab-container" : ""}`} onClick={() => setTabValue("all")}>All</div>
                        <div className={`tab-container ${tabValue === "unread" ? "selected-tab-container" : ""}`} onClick={() => setTabValue("unread")}>Unread</div>
                    </div>
                    <div className="my-3 mx-2">
                        <CheckBox
                            label={"Select All"}
                            values={checkAll && (selectedNotification?.length === notificationListing?.data?.filter((item) => item?.is_read !== 1)?.length)}
                            onChange={(e) => { handleCheckAllOnChange(!checkAll) }}
                        />
                    </div>
                    <div className="mt-3">
                        {notificationListing?.data?.length > 0 ? notificationListing?.data?.map((x, idx) =>
                            <Card style={{ cursor: 'pointer' }} key={x?.id} onClick={() => { handleOpenNotification(x?.id) }}>
                                <CardBody>
                                    <Grid container className="align-items-center" spacing={1}>
                                        <Grid item lg={0.5} sm={0.8} xs={1.5} className="d-flex align-items-center">
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <CheckBox
                                                    values={selectedNotification?.includes(x?.id)}
                                                    onChange={(e) => { handleCheckBoxChange(e, x?.id) }}
                                                    disabled={x?.is_read === 1}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item lg={11.5} sm={11.2} xs={10.5}>
                                            <div className="d-flex justify-content-between text-semibold font-size-16 align-items-center">
                                                <div>{x?.title}</div>
                                                {/* if not readed */}
                                                {
                                                    x?.is_read ? null :
                                                        <div><i className="ri-circle-fill" style={{ color: '#BA2727' }} /></div>
                                                }

                                            </div>
                                            <div className="d-flex justify-content-between text-semibold font-size-14 align-items-center mt-2" style={{ color: '#A0A0A0' }}>
                                                <div>{x?.message}</div>
                                                <div>{x?.created_at}</div>
                                            </div>
                                        </Grid>

                                    </Grid>
                                </CardBody>
                            </Card>)
                            :
                            <div className="text-center py-5 text-muted">No notifications found</div>
                        }
                    </div>
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={notificationListing?.last_page || 1}
                        total={notificationListing?.total || 0}
                        from={notificationListing?.from || 0}
                        to={notificationListing?.to || 0}
                    />
                </Container>
                <AppDialog
                    open={openNotification}
                    close={() => { setOpenNotification(false); setSelectedRowID(""); handleMarkAsRead(); }}
                    title={
                        <div className=" font-size-16 mt-2">
                            {notificationDetails?.title}
                            <div className="font-size-14" style={{ marginRight: 25, color: '#A0A0A0', fontWeight: 500 }}>Received on: {notificationDetails?.updated_at || '-'}</div>
                        </div>}
                    negativePress={() => { setOpenNotification(false); setSelectedRowID(""); handleMarkAsRead(); }}
                    negativeButtonStyle={{ height: 32, padding: 5, paddingInline: 10, border: '1px solid #DDDDDD', backgroundColor: 'white', color: '#000000' }}
                    positivePress={() => notificationDetails?.ref ? navigate(`/${notificationDetails.type}${notificationDetails.ref ? `/${notificationDetails.ref}` : ''}`) : null}
                    positiveButtonStyle={{ height: 32, padding: 5, paddingInline: 10, backgroundColor: 'var(--bs-theme-color)', color: 'white', border: '1px solid var(--bs-theme-color)' }}
                    positiveTitle={notificationDetails?.ref ? 'View Details' : ''}
                    negativeTitle={'Close'}
                    width={'70%'}
                >
                    <NotificationDetails id={selectedRowID} />
                </AppDialog>
                <CustomDrawer
                    filterData={filterList}
                    drawerOpen={drawerOpen}
                    anchor={"right"}
                    applyFilter={applyFilter}
                    resetFilter={resetFilter}
                    setDrawerOpen={setDrawerOpen}
                />
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Notification }) {
    return {
        userPermission: Login.permissionArry,
        notificationListing: Notification?.notificationListing?.data,
        notificationDetails: Notification?.notificationDetails,
        readNotification: Notification?.readNotification,
    };
}

export default connect(mapStateToProps)(ViewNotification);
